var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{on:{"contextmenu":function($event){return _vm.hideContext($event)}}},[_c('router-view'),_c('snackbar-handler'),_c('dialog-handler'),_c('v-overlay',{attrs:{"value":_vm.isLoading}},[_c('breeding-rhombus-spinner',{attrs:{"animation-duration":2000,"size":65,"color":"#E31837"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }